// project import
import dashboard from './dashboard';
import userMaster from './userMaster'
import masterData from './masterData'
import report from './reports'
import approval from './approval'
import documents from './documents'
import query from './query';
import orders from './orders';
import iam from './iam';
import distributorrequest from './distributor';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard,userMaster,masterData,report,approval,documents,query,orders,distributorrequest,iam]
};

export default menuItems;
